import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { hasSubmenu } from '../../redux/menu';
import ErrorBlock from '../ErrorBlock';
import { TEMPLATE_LAYOUT_MAP } from '../shared/layout/LayoutMap';
import { performApiRequest, getResultData, getApiDataRequest, invalidateApiDataRequest } from '../../redux/apiData';
import { getErrorBlockProps } from '../../constants/errorMessages';
import ContentLoader from '../shared/ui/ContentLoader';
import LayoutBase from '../shared/layout/LayoutBase';
import getLinkFromPageObject from '../../services/getLinkFromPageObject';
import get from 'lodash.get';
import withSettings from '../WithSettings';
import PageModalHandler from '@/components/PageModalHandler';
var mapStateToProps = function mapStateToProps(state, ownProps) {
  var _ownProps$match$param = ownProps.match.params,
    projectSlug = _ownProps$match$param.projectSlug,
    env = _ownProps$match$param.env;
  var pagePath = getLinkFromPageObject(ownProps.match.params);
  return {
    redirect: get(state, 'redirect'),
    page: getResultData(state.apiData, 'getPage', {
      pagePath: pagePath
    }),
    settings: getResultData(state.apiData, 'getSettings', {
      projectSlug: String(projectSlug),
      env: String(env)
    }),
    request: getApiDataRequest(state.apiData, 'getPage', {
      pagePath: pagePath
    }),
    resultWishList: getResultData(state.apiData, 'postWishList', {
      projectSlug: String(projectSlug)
    })
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    getNewPage: function getNewPage(env, pagePath) {
      dispatch(performApiRequest('getPage', {
        pagePath: pagePath
      }, undefined, {
        cache: env === 'closed' ? 'disabled' : 'enabled'
      }));
    },
    createWishList: function createWishList(projectSlug, wishListId) {
      dispatch(performApiRequest('postWishList', {
        projectSlug: projectSlug
      }, {
        house: wishListId
      }));
      dispatch(invalidateApiDataRequest('postWishList', {
        projectSlug: projectSlug
      }));
    }
  };
};
var Page = /*#__PURE__*/function (_PureComponent) {
  function Page() {
    _classCallCheck(this, Page);
    return _callSuper(this, Page, arguments);
  }
  _inherits(Page, _PureComponent);
  return _createClass(Page, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
        match = _this$props.match,
        getNewPage = _this$props.getNewPage;
      var env = match.params.env;
      var pagePath = getLinkFromPageObject(match.params);
      getNewPage(String(env), pagePath);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props2 = this.props,
        match = _this$props2.match,
        router = _this$props2.router,
        settings = _this$props2.settings,
        page = _this$props2.page,
        request = _this$props2.request,
        redirect = _this$props2.redirect,
        getNewPage = _this$props2.getNewPage,
        resultWishList = _this$props2.resultWishList,
        createWishList = _this$props2.createWishList;
      var oldMatch = prevProps.match,
        oldSettings = prevProps.settings;
      var _match$params = match.params,
        newProjectSlug = _match$params.projectSlug,
        newEnv = _match$params.env,
        newMenuSlug = _match$params.menuSlug,
        newPageSlug = _match$params.pageSlug;
      var oldPagePath = getLinkFromPageObject(oldMatch.params);
      var newPagePath = getLinkFromPageObject(match.params);
      var newPhase = settings && settings.phase;
      var oldPhase = oldSettings && oldSettings.phase;

      // When cache is cleared:
      if ((settings === undefined || page === undefined) && request && request.networkStatus !== 'loading' && request.networkStatus !== 'failed') {
        getNewPage(String(newEnv), newPagePath);
        return;
      }

      // If an extra page is set under home, we must redirect to the first page under that header
      if (settings && settings.menu && settings.menu.length > 0 && hasSubmenu(settings.menu[0]) && Array.isArray(settings.menu[0].pages) && !newMenuSlug && !newPageSlug) {
        var _settings$menu$0$page = settings.menu[0].pages[0],
          _projectSlug = _settings$menu$0$page.projectSlug,
          _env = _settings$menu$0$page.env;
        router === null || router === void 0 || router.push("/".concat(getLinkFromPageObject({
          projectSlug: _projectSlug,
          env: _env,
          menuSlug: 'home'
        })));
      }

      // When navigating from one page to another:
      if (oldPagePath !== newPagePath || oldPhase !== undefined && oldPhase !== newPhase) {
        if (redirect.params && settings && settings.user && !resultWishList) {
          createWishList(String(newProjectSlug), redirect.params.wishListId);
        } else {
          if (!settings) {
            // When there are no settings, it means you cant navigate to anything other than /env
            getNewPage(String(newEnv), getLinkFromPageObject({
              projectSlug: newProjectSlug,
              env: newEnv
            }));
          } else {
            getNewPage(String(newEnv), newPagePath);
          }
        }
      }

      // When a wishlist is created, the user will be navigated to the wishlist page
      if (resultWishList && resultWishList.id && redirect.params && settings && settings.user) {
        router === null || router === void 0 || router.push("/".concat(String(newProjectSlug), "/closed/homestudio/").concat(resultWishList.id));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        settings = _this$props3.settings,
        settingsRequest = _this$props3.settingsRequest,
        page = _this$props3.page,
        request = _this$props3.request,
        match = _this$props3.match,
        renderWidth = _this$props3.renderWidth;
      var pageTemplate = get(page, 'template');
      var pageNotFound = get(request, 'response.status') === 404;
      var title = page && settings ? "".concat(page.name, " - ").concat(settings.siteName) : '';
      var meta = page ? {
        metaTitle: page.metaTitle,
        metaKeywords: page.metaKeywords,
        metaDescription: page.metaDescription
      } : {};
      var Layout = settings && pageTemplate && TEMPLATE_LAYOUT_MAP[pageTemplate] || TEMPLATE_LAYOUT_MAP.flex;
      var layoutSettings = {
        hasHeader: true,
        hasFooter: true,
        hasMenu: !(page && page.template === 'notLoggedIn')
      };
      return __jsx(LayoutBase, {
        settings: settings,
        layoutSettings: layoutSettings,
        renderWidth: renderWidth,
        title: title,
        meta: meta,
        "data-id": "contentTypes_Page_LayoutBase"
      }, __jsx(PageModalHandler, {
        "data-id": "contentTypes_Page_PageModalHandler"
      }), Layout && page && request.networkStatus !== 'loading' && settingsRequest.networkStatus !== 'loading' && !pageNotFound && __jsx(Layout, {
        page: page,
        request: request,
        renderWidth: renderWidth,
        "data-id": "contentTypes_Page_Layout"
      }), (request && request.networkStatus === 'loading' || !settingsRequest || settingsRequest && settingsRequest.networkStatus === 'loading') && __jsx(ContentLoader, {
        big: true,
        "data-id": "contentTypes_Page_ContentLoader"
      }), pageNotFound && request && request.networkStatus !== 'loading' && __jsx(ErrorBlock, _extends({}, getErrorBlockProps(match, 'page', 404), {
        "data-id": "contentTypes_Page_ErrorBlock"
      })));
    }
  }]);
}(PureComponent);
export default withSettings(connect(mapStateToProps, mapDispatchToProps)(Page));